/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_apex_avoid_remove = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.name} from avoid list`)
};

const es_f1_apex_avoid_remove = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quitar a ${i?.name} de la lista de evitados`)
};

const de_f1_apex_avoid_remove = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} von der Vermeiden-Liste entfernen`)
};

const nl_f1_apex_avoid_remove = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} van de vermijdlijst verwijderen`)
};

const fr_f1_apex_avoid_remove = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Retirer ${i?.name} de la liste d'exclusion`)
};

const it_f1_apex_avoid_remove = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rimuovi ${i?.name} dalla lista da evitare`)
};

const pt_br2_f1_apex_avoid_remove = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remover ${i?.name} da lista de exclusão`)
};

const pt_f1_apex_avoid_remove = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remover ${i?.name} da lista a evitar`)
};

const ja_f1_apex_avoid_remove = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}を回避リストから削除`)
};

const zh_f1_apex_avoid_remove = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`将${i?.name}从回避名单中移除`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ name: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_apex_avoid_remove = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_apex_avoid_remove(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_apex_avoid_remove", locale)
	if (locale === "en") return en_f1_apex_avoid_remove(inputs)
	if (locale === "es") return es_f1_apex_avoid_remove(inputs)
	if (locale === "de") return de_f1_apex_avoid_remove(inputs)
	if (locale === "nl") return nl_f1_apex_avoid_remove(inputs)
	if (locale === "fr") return fr_f1_apex_avoid_remove(inputs)
	if (locale === "it") return it_f1_apex_avoid_remove(inputs)
	if (locale === "pt-BR") return pt_br2_f1_apex_avoid_remove(inputs)
	if (locale === "pt") return pt_f1_apex_avoid_remove(inputs)
	if (locale === "ja") return ja_f1_apex_avoid_remove(inputs)
	return zh_f1_apex_avoid_remove(inputs)
};